import { ErrorCode } from "src/Pages/Company/OrganizationStructure/utils/errors/errorCode";
import { FieldValues, Path } from "react-hook-form";

export interface BackendError {
  code: string;
  field: string;
  message: string;
}

interface ProcessedError<T extends FieldValues> {
  field: Path<T>;
  message: string;
}

export const handleBackendErrors = <T extends FieldValues>(
  errors: BackendError[],
  errorMessages: Record<string, (field?: string) => string>
): ProcessedError<T>[] => {
  if (!errors || !Array.isArray(errors)) {
    return [];
  }

  return errors.map((err) => {
    const field = err.field as Path<T>;
    const errorCode = err.message as ErrorCode;

    const errorMessage = errorMessages[errorCode]?.(field) || err.message;

    return { field, message: errorMessage };
  });
};
